import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '@/shared/styles/blank.scss';
import '@/shared/styles/fonts.scss';
import '@/shared/styles/main.scss';
import '@/shared/styles/animations.scss';
import ModalContextProvider from './context/Modals';
import { AuthContextProvider } from './context/AuthContext';
import { PrivateRoute } from './router/PrivateRoute';
import { SuperAdminRoute } from './router/SuperAdminRoute';
import ProjectList from '@/pages/projects/ProjectList';
import ProjectCreate from '@/pages/projects/ProjectCreate';
import ProjectUpdate from '@/pages/projects/ProjectUpdate';
import ProjectManage from '@/pages/project_manage/ProjectManage';
import ProjectArchivedCases from '@/pages/project_manage/ProjectArchivedCases';
import EmployeeCreate from '@/pages/employees/EmployeeCreate';
import EmployeeList from '@/pages/employees/EmployeeList';
import EmployeeUpdate from '@/pages/employees/EmployeeUpdate';
import CreateTestCase from '@/pages/test_cases/CreateTestCase';
import UpdateTestCase from '@/pages/test_cases/UpdateTestCase';
import ProjectTestRunsManage from '@/pages/project_manage/ProjectTestRunsManage';

const SignIn = lazy(() => import('../pages/auth/SignIn/SignIn'));

function AppRouter() {
    return (
        <Suspense fallback={null}>
            <AuthContextProvider>
                <ModalContextProvider>
                    <Router>
                        <Routes>
                            {/* Авторизация — открытый роут */}
                            <Route path="/auth" element={<SignIn />} />

                            {/* Защищённые роуты */}
                            <Route element={<PrivateRoute />}>
                                <Route path="/" element={<ProjectList />} />
                                {/* Проекты */}
                                <Route path="/projects" element={<ProjectList />} />
                                <Route path="/projects/create" element={<ProjectCreate />} />
                                <Route path="/projects/update/:projectID" element={<ProjectUpdate />} />
                                {/* Управление проектом */}
                                <Route path="/projects/manage/:projectID" element={<ProjectManage />} />
                                <Route path="/projects/manage/:projectID/cases" element={<ProjectManage />} />
                                <Route path="/projects/manage/:projectID/archived" element={<ProjectArchivedCases />} />
                                <Route path="/projects/manage/:projectID/test_runs" element={<ProjectTestRunsManage />} />
                                {/* Тест-кейсы */}
                                <Route path="/test_cases/create" element={<CreateTestCase />} />
                                <Route path="/test_cases/update/:caseID" element={<UpdateTestCase />} />
                                {/* Сотрудники — только superadmin */}
                                <Route element={<SuperAdminRoute />}>
                                    <Route path="/employees" element={<EmployeeList />} />
                                    <Route path="/employees/create" element={<EmployeeCreate />} />
                                    <Route path="/employees/update/:employeeID/" element={<EmployeeUpdate />} />
                                </Route>
                            </Route>
                        </Routes>
                    </Router>
                </ModalContextProvider>
            </AuthContextProvider>
        </Suspense>
    );
}

export default AppRouter;
